<template>
  <div class="blackScreen_container">
    <div class="title-box">
      <h3>道路环保监控系统</h3>
    </div>
    <div class="title-monitor-box">
      <transition name="plus-icon">
        <div class="current_box" v-if="currentRow == 1">
          <div class="key-list wendu">
            <div class="box1">
              <div class="img"><img src="./img/pm10.png">
              </div>
              <div class="key-name">PM10:</div>
            </div>
            <div class="box2">
              {{getValue('61')}}{{getUnit('61')||'μm/m³'}}
            </div>
          </div>
          <div class="key-list shidu">
            <div class="box1">
              <div class="img"><img src="./img/pm25.png">
              </div>
              <div class="key-name">PM2.5:</div>
            </div>
            <div class="box2">
              {{getValue('62')}}{{getUnit('62')||'μm/m³'}}
            </div>
          </div>
        </div>
        <div class="current_box" v-else-if="currentRow == 2">
          <div class="key-list wendu">
            <div class="box1">
              <div class="img"><img src="./img/wendu.png">
              </div>
              <div class="key-name">温度:</div>
            </div>
            <div class="box2">
              {{getValue('8')}}{{getUnit('8')||'℃'}}
            </div>
          </div>
          <div class="key-list shidu">
            <div class="box1">
              <div class="img"><img src="./img/shidu.png">
              </div>
              <div class="key-name">湿度:</div>
            </div>
            <div class="box2">
              {{getValue('22')}}{{getUnit('22')||'%'}}
            </div>
          </div>
        </div>
        <div class="current_box" v-else-if="currentRow == 3">
          <div class="key-list wendu">
            <div class="box1">
              <div class="img"><img src="./img/fengsu.png">
              </div>
              <div class="key-name">风速:</div>
            </div>
            <div class="box2">
              {{getValue('65')}}
              {{getUnit('65')||'m/s'}}
            </div>
          </div>
          <div class="key-list shidu">
            <div class="box1">
              <div class="img"><img src="./img/fengxiang.png">
              </div>
              <div class="key-name">风向:</div>
            </div>
            <div class="box2">
              {{getValue('63')}}
              {{getUnit('63')}}
            </div>
          </div>
        </div>
        <div class="current_box" v-else-if="currentRow == 4">
          <div class="key-list wendu">
            <div class="box1">
              <div class="img"><img src="./img/jiangyu.png">
              </div>
              <div class="key-name">降雨量:</div>
            </div>
            <div class="box2">
              {{getValue('600')}}{{getUnit('600')||'mm'}}
            </div>
          </div>

        </div>
      </transition>
    </div>
    <div class="large-text">
      <h3 class="road-name">{{roadData.roadName}}</h3>
      <div class="status-box">
        <el-row>
          <el-col :span="14">
            <div class="led-key">干湿状态：</div>
          </el-col>
          <el-col :span="10">
            <div class="led-value">{{roadData.dryWetStatus}}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="14">
            <div class="led-key">今日保湿：</div>
          </el-col>
          <el-col :span="10">
            <div class="led-value">{{roadData.moisturizeTimes}}次</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="14">
            <div class="led-key">今日清扫：</div>
          </el-col>
          <el-col :span="10">
            <div class="led-value">{{roadData.cleanupTimes}}次</div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {},
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      keyList: [{ name: "洒水车" }, { name: "洗扫车" }],
      dataList: [],
      roadList: [],
      roadData: {},
      timer: null,
      timer2: null,
      timer3: null,
      currentRow: 1,
      timerTitleShow: null,
    };
  },
  //计算属性 类似于data概念
  computed: {
    getValue() {
      return (key) => {
        if (!this.dataList.length) return;
        let arr = this.dataList.filter((i) => i.categoryId == key);
        return arr[0] && arr[0].value;
      };
    },
    getUnit() {
      return (key) => {
        if (!this.dataList.length) return;
        let arr = this.dataList.filter((i) => i.categoryId == key);
        return arr[0] && arr[0].unit;
      };
    },
  },
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getAllData();
    this.getAllData2();
    this.getShowData();
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (this.timer2) {
      clearInterval(this.timer2);
    }
    if (this.timer3) {
      clearTimeout(this.timer3);
    }
    if (this.timerTitleShow) {
      clearTimeout(this.timerTitleShow);
    }
  },
  //方法集合
  methods: {
    getShowData() {
      if (this.timerTitleShow) {
        clearTimeout(this.timerTitleShow);
      }
      this.currentRow++;
      if (this.currentRow > 4) {
        this.currentRow = 1;
      }
      this.timerTitleShow = setTimeout(() => {
        this.getShowData();
      }, 1000 * 5);
    },
    getAllData() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.getData();
      // this.getRoadData();
      this.timer = setTimeout(() => {
        this.getAllData();
      }, 1000 * 60 * 5);
    },
    getAllData2() {
      if (this.timer3) {
        clearTimeout(this.timer3);
        this.timer3 = null;
      }
      this.getRoadData();
      this.timer3 = setTimeout(() => {
        this.getAllData();
      }, 1000 * 60 * 20);
    },
    async getData() {
      const url = `${CONFIG.requestNameRoad}/digit/getSignalRealValue`;
      const res = await this.$apiUtils.get(url, {
        ledNo: "rf_rgb_led_1",
        customerId: this.customerId,
      });
      this.dataList = res || [];
    },
    async getRoadData() {
      if (this.timer2) {
        clearInterval(this.timer2);
        this.timer2 = null;
      }
      const url = `${CONFIG.requestNameRoad}/digit/roadList`;
      const res = await this.$apiUtils.get(url, {
        customerId: this.customerId,
        roadId: null,
      });
      this.roadList = res || [];
      let length = res.length;
      let i = 0;
      this.roadData = res[i];
      this.timer2 = setInterval(() => {
        if (i < length) {
          this.roadData = res[i];
          i++;
        } else {
          i = 0;
          this.roadData = res[i];
        }
      }, 10000);
    },
  },
};
</script>
<style scoped lang="scss" >
.blackScreen_container {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  background: #000;
  pointer-events: all;
  .title-box {
    height: 247px;
    h3 {
      font-size: 66px;
      font-weight: 500;
      color: #519eff;
      line-height: 247px;
      text-align: center;
    }
  }
  .title-monitor-box {
    height: 633px;
    background: rgba(250, 82, 78, 0.03);
    border: 5px dashed #e54646;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    position: relative;
    .current_box {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      align-content: space-around;
      justify-content: space-evenly;
      flex-direction: column;
      .key-list {
        display: flex;
        .box1 {
          width: 44%;
          display: flex;
          align-items: center;
          justify-content: center;
          .img {
            width: 80px;
            height: 80px;
            // object-fit: contain;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .key-name {
            margin-left: 40px;
            font-size: 79px;
            font-weight: 500;
            color: #fa524e;
            line-height: 111px;
          }
        }
        .box2 {
          width: 56%;
          font-size: 100px;
          font-weight: 500;
          color: #fa524e;
          line-height: 168px;
          border-bottom: 2px solid #fa524e;
          text-align: end;
          margin-right: 50px;
          white-space: nowrap;
        }
      }
    }
  }
  .large-text {
    height: 1040px;
    .road-name {
      font-size: 110px;
      font-weight: 500;
      color: #519eff;
      line-height: 293px;
      text-align: center;
      white-space: nowrap;
    }
    :deep(.status-box) {
      .el-row {
        margin-bottom: 95px;
        padding: 0 35px;
        .led-key,
        .led-value {
          font-size: 129px;
          font-weight: 500;
          color: #4efaa2;
          line-height: 129px;
          white-space: nowrap;
        }
        .led-value {
          float: right;
          white-space: nowrap;
        }
      }
    }
  }
}
.plus-icon-enter-active {
  transition: opacity 0.5s;
}
.plus-icon-enter {
  opacity: 0;
}
.plus-icon-leave-active {
  transition: opacity 0.5s;
}
.plus-icon-leave-to {
  opacity: 0;
}
</style>